<template>

  <div class="form form-search">
    <div class="form-group">
      <input type="text" placeholder="Enter name, nickname, or email" class="form-control" v-model="searchTerm" @keyup="showSearchResults" ref="emailInput">
      <input type="submit" value="Search" class="form-search__button" @click="showSearchResults" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchCustomers',
  emits: ['updateCustomers'],
  methods: {
    showSearchResults() {
      if (typeof this.searchTerm !== 'undefined' && this.searchTerm !== '') {
        if (this.$route.name === 'Home') {
          this.$router.push('/search-results/customer/term/' + this.searchTerm);
        }
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit('updateCustomers', this.searchTerm);
        }, 150);
        history.pushState({}, '', '/search-results/customer/term/' + this.searchTerm);
      } else {
        this.$router.push('/home/');
      }
    }
  },
  data() {
    return {
      searchTerm: this.$route.params.term
    }
  },
  mounted() {
    this.$refs.emailInput.focus();
  }
}
</script>
